import type React from 'react';
import { getVideoHost, getImageHost } from '@wix/communities-blog-client-common';
import { connect } from '../components/runtime-context';

export type WithMediaHosts = {
  videoHost?: string;
  imageHost?: string;
};

const withMediaHosts = <P extends WithMediaHosts>(WrappedComponent: React.ComponentType<P>) => {
  const mapRuntimeToProps = (state: Parameters<typeof getVideoHost>[0]) => ({
    videoHost: getVideoHost(state),
    imageHost: getImageHost(state),
  });

  return connect(mapRuntimeToProps)(
    WrappedComponent as React.ComponentType<WithMediaHosts>,
  ) as React.ComponentType<Omit<P, keyof WithMediaHosts>>;
};

export default withMediaHosts;
